module.exports = __webpack_public_path__ + "static/img/03.fd4e8af.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/apps/03.png
// module id = GDKH
// module chunks = 0